import apiCall from "@/scripts/axiosService"

function createQueryString(_query, _prefix = '?') {
    return _prefix + new URLSearchParams(_query)
}
export { apiCall, createQueryString }